import { PackingSlipRouteService } from 'common/data';
import { BaseService } from 'core/services';

class PackingSlipService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PackingSlipRouteService());
	}
	generatePdf(id) {
		var url = this.routeService.generatePdf(id);
		return this.apiClient.get(url);
	}
}

export default PackingSlipService;



// WEBPACK FOOTER //
// ./src/common/data/services/PackingSlipService.js